import { c as _c } from "react/compiler-runtime";
import { Box, Stack, type ButtonOwnProps, Typography } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';
import { Loader } from '@/components/layout/loading';
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
interface ButtonProps {
  text: string;
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  disabledTooltip?: string;
  variant?: ButtonOwnProps['variant'];
  'data-testid': string;
  icon?: string | ReactNode;
}
export interface PanelFooterProps extends PropsWithChildren {
  primaryButton: ButtonProps;
  secondaryButton?: ButtonProps;
  submitInProgress?: boolean;
  loadingText?: string;
  hideButtons?: boolean;
}
export const PanelFooter = props => {
  const $ = _c(17);
  const {
    primaryButton,
    secondaryButton,
    children,
    submitInProgress,
    loadingText,
    hideButtons
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      boxShadow: "var(--mui-customShadows-panelMd)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children) {
    t1 = <Box flexGrow={1}>{children}</Box>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== loadingText || $[4] !== submitInProgress) {
    t2 = submitInProgress && <><Loader variant="inline" /><Typography>{loadingText || "Loading..."}</Typography></>;
    $[3] = loadingText;
    $[4] = submitInProgress;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== hideButtons || $[7] !== primaryButton || $[8] !== secondaryButton || $[9] !== submitInProgress) {
    t3 = !submitInProgress && !hideButtons && <>{secondaryButton && <ButtonWithIcon {...secondaryButton} variant={secondaryButton.variant || "text"} />}<ButtonWithIcon {...primaryButton} variant={primaryButton.variant || "contained"} /></>;
    $[6] = hideButtons;
    $[7] = primaryButton;
    $[8] = secondaryButton;
    $[9] = submitInProgress;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <Stack direction="row" gap="12px">{t2}{t3}</Stack>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t4) {
    t5 = <Stack gap="40px" direction="row" justifyContent="space-between" alignItems="center" paddingX="40px" paddingY="16px" sx={t0}>{t1}{t4}</Stack>;
    $[14] = t1;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};